__webpack_require__.p = "/de/en/customer-service/returns-claims/spareparts/";